import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'
import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import { WarningIcon } from '@/app/common/icons/support'
import { AppRoutePaths } from '@/routing/route_paths'
import { useNavigate } from 'react-router-dom'
import MarketplaceUI from '../components/MarketplaceUI'
import { TABLE_FILTERS } from '../constants'
import { useMarketplacePreviewData } from './hooks/useMarketplacePreviewData'

export function MarketplacePreviewPage() {
  const navigate = useNavigate()

  const {
    itemSearch,
    setItemSearch,
    isStoresView,
    currentPage,
    perPage,
    setStoreSearch,
    storeSearch,
    setCurrentPage,
    setPerPage,
    handleFilterOnChange,
    storesQuery,
    itemsQuery,
    handleToggleView,
  } = useMarketplacePreviewData()

  const handleShopClick = (item: MarketplaceItem) => {
    navigate(
      AppRoutePaths.marketplace_preview.details.replace(
        ':itemId',
        item.id.toString()
      )
    )
  }

  function handleProviderClick(providerId: number) {
    navigate(
      AppRoutePaths.marketplace_preview.provider_details.replace(
        ':providerId',
        providerId.toString()
      )
    )
  }

  const stores = storesQuery.data ? [storesQuery.data] : []
  const items = itemsQuery.data?.data ?? []

  const currentView = isStoresView ? 'stores' : 'items'

  const search = isStoresView ? storeSearch : itemSearch
  const setSearch = isStoresView ? setStoreSearch : setItemSearch
  const totalRecords = isStoresView ? 1 : (itemsQuery.data?.total ?? 0)

  return (
    <>
      <div className="">
        <MarketplaceUI
          handleStoreClick={handleProviderClick}
          items={items}
          stores={stores}
          affiliations={[]}
          totalRecords={totalRecords}
          search={search}
          currentView={currentView}
          currentPage={currentPage}
          perPage={perPage}
          filters={TABLE_FILTERS}
          onSearchChange={setSearch}
          onViewChange={(view) =>
            handleToggleView(view === 'stores' ? 'stores' : 'items')
          }
          onFilterChange={handleFilterOnChange}
          onItemClick={handleShopClick}
          onAffiliationClick={() => {}}
          onProviderClick={handleProviderClick}
          onPageChange={setCurrentPage}
          onPerPageChange={setPerPage}
          // Marketplace preview should not have a cart.
          // So we hide the cart and do nothing.
          hideCart={() => {}}
          showCart={false}
          showAffiliationsView={false}
        />
        {stores[0]?.marketplace === 0 && (
          <Card className="mt-4">
            <CardHeader className="flex items-center gap-2 font-medium">
              <WarningIcon className="text-yellow-500 text-lg" />
              <h1>Your marketplace is turned off</h1>
            </CardHeader>
            <CardContent>
              <div className="text-sm text-gray-700">
                <p>
                  Your marketplace is currently disabled and not visible to the
                  public. You can still preview your items here, but customers
                  won't be able to see or purchase from your store.
                </p>
                <p className="mt-3">
                  <strong>To make your marketplace public:</strong> Go to
                  marketplace settings and enable "Display Store in
                  Marketplace".
                </p>
                <p className="mt-3 text-sm text-gray-500">
                  Need help? Contact your administrator.
                </p>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </>
  )
}
